export default __webpack_public_path__ + "static/oleksandra-nedashkivska-c2df875a1d1a32cfbed77d82a819eed8.png";